import Crud from '@/stores/crudBase';
import api from '@/apis/in/inInwardOutwardAPI.js';
var crud = new Crud('approveVoucherINInwardTab', api);

const state = {
  ...crud.state,
  _config: {
    table: 'in_inward_outward',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
